module.exports = __webpack_public_path__ + "components/flag/static/square/ec-cb74f1183307c5de58feded5d81b2d4f.svg";